<template>
  <div class="inventory">
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>
    <label>Переучет товара: </label>
    <div class="md-layout md-gutter md-alignment-center-center">
      <div class="md-layout-item">
        <md-field>
          <md-select v-if="!loading" v-model="warehouseId" id="warehouseId">
            <md-option
                     v-for="(item, index) in this.warehouses"
                      :key="item.code"
                      :value="item.code"
            >
              {{ item.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-button type="button" class="md-raised md-primary" v-on:click.prevent="getListDoc" :disabled="loading">Получить список</md-button>
      </div>
    </div>
    <md-content class="md-layout leftovers-mobile-table">
      <div class="md-layout-item md-size-100">
        <md-table
            md-card
            class="md-scrollbar"
            :style="{
                overflow: 'auto',
                marginRight: 0,
                marginLeft: 0,
              }"
        >
          <md-table-row>
            <md-table-head>Поставщик</md-table-head>
            <md-table-head></md-table-head>
          </md-table-row>
          <md-table-row
              v-for="(item, index) in this.list"
              :key="item.uniqueId"
              slot="md-table-row"
          >
            <md-table-cell md-label="Поставщик">
              {{ index+1 }} {{ item.description }}
            </md-table-cell>
            <md-table-cell md-label="Получить документ">
              <router-link :to="{name: 'viewInventoryDocument', params: { docId: item.uniqueId }}">
                <span>Получить документ</span>
              </router-link>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </md-content>
  </div>
</template>

<script>

export default {
  name: "Inventory",
  data: () => ({
    loading: false,
    warehouses: [],
    list: [],
    warehouseId: false
  }),
  methods: {
    getListDoc: function () {
      this.$axios
          .get("/inventory/get-list-doc/" + this.warehouseId)
          .then((response) => {
            if (typeof response.data === "object" && response.data.length) {
              this.list = response.data;
            }
          })
          .catch(error => {
            this.$store.commit("messages/setMessage", {
              type: "error",
              code: "Ой все!",
              message: 'Ошибка сервера',
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getListWarehouse: function () {
      this.loading = true;
      this.$axios
          .get("/inventory/warehouses")
          .then((response) => {
            if (typeof response.data === "object" && response.data.length) {
              this.warehouses = response.data;
              this.warehouseId = response.data[0].code;
            }
          })
          .catch(error => {
            this.$store.commit("messages/setMessage", {
              type: "error",
              code: "Ой все!",
              message: 'Ошибка сервера',
            });
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  mounted() {
    this.getListWarehouse();
  }
};
</script>

<style lang="scss" scoped>
  .inventory {
    padding: 8px;
  }

.md-content.md-table-content table {
  min-width: 25%;
  max-width: 25%;
  flex: 0 1 25%;
  @media (max-width: 460px) {
    min-width: 100%;
    max-width: 100%;
    flex: 0 1 100%;
  }
}

.md-content.md-table-content table thead th:nth-child(1) {
 width: 100px;
}
</style>
